var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Subject } from "rxjs";
import { NotificationsProvider, Injectable } from "@banta/common";
import { FirebaseStoreRef } from "./firebase-store-ref";
import { v4 as uuid } from 'uuid';
let FirebaseNotificationsProvider = class FirebaseNotificationsProvider extends NotificationsProvider {
    constructor(storeRef) {
        super();
        this.storeRef = storeRef;
        this._received = new Subject();
        this._current = [];
    }
    get user() {
        return this._user;
    }
    set user(value) {
        this._user = value;
        this.subscribeToUser();
    }
    get datastore() {
        return this.storeRef.store;
    }
    get received() {
        return this._received;
    }
    get current() {
        return this._current;
    }
    subscribeToUser() {
        if (this._notificationsSubscription) {
            this._notificationsSubscription.unsubscribe();
            this._notificationsSubscription = null;
        }
        if (this._newNotificationSubscription) {
            this._newNotificationSubscription.unsubscribe();
            this._newNotificationSubscription = null;
        }
        if (!this.user)
            return;
        let path = `/bantaUsers/${this.user.id}/notifications`;
        this._notificationsSubscription = this.datastore
            .watchAll(path, { limit: 50 })
            .subscribe(notifs => this._current = notifs);
        this._newNotificationSubscription = this.datastore
            .watchForChanges(path)
            .subscribe(c => c.filter(x => x.type === 'added')
            .forEach(n => this._received.next(n.document)));
    }
    send(notification) {
        return __awaiter(this, void 0, void 0, function* () {
            let finalNotification = notification;
            yield Promise.all([
                this.datastore.update(`/bantaUsers/${notification.recipientId}/notifications/:id`, finalNotification = Object.assign({}, notification, {
                    id: uuid(),
                    sentAt: Date.now()
                })),
                this.datastore.update(`/bantaUsers/${notification.recipientId}/counters/notifications`, { value: this.datastore.sentinels.increment(1) })
            ]);
            return finalNotification;
        });
    }
};
FirebaseNotificationsProvider = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [FirebaseStoreRef])
], FirebaseNotificationsProvider);
export { FirebaseNotificationsProvider };
//# sourceMappingURL=firebase-notifications-provider.js.map